import { jsx } from "react/jsx-runtime";
import { useClassName } from "@contember/react-utils";
import { memo, forwardRef, useMemo } from "react";
import { useFallbackRef } from "../../utils/useFallbackRef.js";
const Grid = memo(forwardRef(({
  className,
  columnWidth,
  children,
  style: styleProp,
  ...rest
}, forwardedRef) => {
  if (columnWidth < 0) {
    throw new Error("Column width must be a non-negative number");
  }
  const ref = useFallbackRef(forwardedRef);
  const style = useMemo(() => columnWidth ? {
    ["--cui-grid-column-width"]: `${columnWidth}px`,
    ...styleProp
  } : styleProp, [columnWidth, styleProp]);
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref,
      className: useClassName("grid", className),
      style,
      ...rest,
      children
    }
  );
}));
Grid.displayName = "Grid";
export {
  Grid
};
//# sourceMappingURL=Grid.js.map
